import { all } from "redux-saga/effects";
import auth from "../auth/sagas";
import stock from "../stock/sagas";
import users from "../users/sagas";
import profiles from "../profiles/sagas";
import company from "../company/sagas";
import transmissionValidator from "../transmissionValidator/sagas";
import history from '../historicalInfo/sagas';
import vehicles from '../vehicles/sagas';
import store from '../store/sagas';
import activeServices from '../activeServices/sagas';
import reports from '../reports/sagas';
import renewalConfigs from '../renewalConfigs/sagas';
import dealers from '../dealers/sagas';
import deviceCommands from '../deviceCommands/sagas';
export default function* () {
    yield all([
        auth(),
        stock(),
        users(),
        profiles(),
        company(),
        transmissionValidator(),
        history(),
        vehicles(),
        store(),
        activeServices(),
        reports(),
        renewalConfigs(),
        dealers(),
        deviceCommands()
    ]);
}
